const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const trim = require('mn-utils/trim');

const {apiAdminMerchantRefundUpdate} = require('../../../../../../../api/admin/refunds');
const {openPopupWindow, openV1PopupInfo} = require('../../../../../../../emitters/popup');
const isSafeNumber = require('../../../../../../../utils/isSafeNumber');
const Popup = require('../../../../../../dumb/Popup/C');
const WrapperWithLoading = require('../../../../../../dumb/WrapperWithLoading');
const TextField = require('../../../../../../dumb/TextField/H');
const {apiAdminMerchantSetLimits} = require("../../../../../../../api/admin/merchants");
const numberHandle = require("../../../../../../../utils/numberHandle");
const {default: IconButton} = require("@material-ui/core/IconButton");

module.exports = ({id, login, limits = {}, update}) => {
  openPopupWindow((setPopupState, popup) => {
    const {
      close,
    } = popup;
    popup.state = {
      ...limits,
      clicked: false,
    };

    const checkAmount = (amount) => {
      if (!amount || amount === 0) return '';

      if (isNaN(amount)) return 'Must be a number';
      if (Number(amount) < 0) return 'Must be higher or equal to zero';
    }

    const onChange = (key) => (e) => {
      const value = numberHandle(e.target.value);
      setPopupState({[key]: value, lastChangedAmountField: key});
    }

    return (stateOfPopup) => {
      const {
        min_amount,
        max_amount,
        lastChangedAmountField
      } = stateOfPopup;

      const amountErrorHelperMin = checkAmount(min_amount);
      const amountErrorHelperMax = checkAmount(max_amount);

      const amountComparisonError = (
        amountErrorHelperMin
        || amountErrorHelperMax
        || !min_amount
        || !max_amount
        || !lastChangedAmountField
          ? ''
          : max_amount - min_amount === 0
            ? 'Amounts should not be equal'
            : lastChangedAmountField === 'min_amount' && max_amount - min_amount < 0
              ? 'Min amount should be lower than max'
              : lastChangedAmountField === 'max_amount' && min_amount - max_amount > 0
                ? 'Max amount should be higher than min'
                : ''
      );

      const errorHelperMin = amountErrorHelperMin || (lastChangedAmountField === 'min_amount' && amountComparisonError);
      const errorHelperMax = amountErrorHelperMax || (lastChangedAmountField === 'max_amount' && amountComparisonError);

      const disabled = errorHelperMin || errorHelperMax;

      return (
        <Popup
          caption={(
            <div className="layoutRow fhaS fvaC w">
              <div>Edit Merchant Limits</div>
              <div className="mh30 fw3 rlv st-2">|</div>
              <div className="f12 fx1 wmin0 tov ov wsNW">{login}</div>
            </div>
          )}
          onCancel={close}
          disabled={stateOfPopup.clicked && disabled}
          onSave={() => {
            if (disabled) {
              setPopupState({
                clicked: true,
              });
              return;
            }

            setPopupState({
              loading: true,
            });

            const params = {
              merchant_id: id,
              min_amount: min_amount || null,
              max_amount: max_amount || null
            };

            apiAdminMerchantSetLimits(params)
                .finally((error) => {
                  setPopupState({
                    loading: false,
                  });
                  if (error) {
                    return;
                  }
                  update();
                  close();
                }).then(() => {
                  openV1PopupInfo([`${login} limits have been changed`]);
                });
          }}
        >
          <WrapperWithLoading
            loading={stateOfPopup.loading}
          >
            <TextField
              className="mt20 wmax472"
              label="Min Amount"
              value={min_amount}
              onChange={onChange('min_amount')}
              error={stateOfPopup.clicked && !!errorHelperMin}
              helperText={errorHelperMin}
              InputProps={{
                endAdornment: <span className="c8B8D93">EUR</span>
              }}
            />
            <TextField
              className="mt20 wmax472"
              label="Max amount"
              value={max_amount}
              onChange={onChange('max_amount')}
              error={stateOfPopup.clicked && !!errorHelperMax}
              helperText={errorHelperMax}
              InputProps={{
                endAdornment: <span className="c8B8D93">EUR</span>
              }}
            />
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
}
